import { AttributesBlock } from "./attributes-block/attributes-block";
import { NewOrderSelectors } from "./selectors-block/new-order-selectors";
import { CountriesBlock } from "./countries-block/countries-block";
import { NewOrderTotalBlock } from "./total-block/new-order-total-block";

type TCreateOrderFormProps = {
  handleReset: () => void;
};

export const CreateOrderForm = ({ handleReset }: TCreateOrderFormProps) => {
  return (
    <>
      <NewOrderSelectors />
      <AttributesBlock />
      <CountriesBlock />
      <NewOrderTotalBlock onReset={handleReset} />
    </>
  );
};
